const notifyError = error => {
    if(window.ADRUM) {
        const errorT = new window.ADRUM.events.Error()
        if(error && error.stack && typeof error.stack.toString === 'function'){
            errorT.msg(`${error.stack.toString()}`)
        }else {
            errorT.msg('error general')
        }
        window.ADRUM.report(errorT)
    }
}

module.exports = { notifyError }